import type { BrandWithSupport } from 'src/graphql';
import { LandingPagePreview } from 'src/pages/Settings/memberships/components/landing-page-preview';
import { MembershipsConfigPreview } from 'src/pages/Settings/memberships/components/memberships-config-preview';
import { useLandingPagePreview } from 'src/pages/Settings/memberships/hooks/use-landing-page-preview';
import type { useLandingPageSurface } from 'src/pages/Settings/memberships/hooks/use-landing-page-surface';
import type { useMembershipsConfigPreview } from 'src/pages/Settings/memberships/hooks/use-memberships-config-preview';
import { toLandingPagePartner } from 'src/pages/Settings/memberships/utils/to-landing-page-partner';
import { useMembershipsConfigStore } from 'src/store/memberships-config';

type ConfigPreviewPaneProps = {
  isLandingPageSurface: boolean;
  preview: ReturnType<typeof useMembershipsConfigPreview>;
  landingPageSurface: ReturnType<typeof useLandingPageSurface>;
  segment?: BrandWithSupport;
  termsOfServiceUrl?: string;
};

export const ConfigPreviewPane = ({
  isLandingPageSurface,
  preview,
  landingPageSurface,
  segment,
  termsOfServiceUrl,
}: ConfigPreviewPaneProps) => {
  const previewViewport = useMembershipsConfigStore.use.previewViewport();
  const setPreviewViewport = useMembershipsConfigStore.use.setPreviewViewport();
  const landingPagePreview = useLandingPagePreview({
    data: landingPageSurface.data,
    liveFormValues: landingPageSurface.liveFormValues,
    storedConfig: landingPageSurface.storedConfig,
    plansConfig: preview.previewConfig,
  });

  if (isLandingPageSurface) {
    return (
      <LandingPagePreview
        config={landingPagePreview.config}
        plans={landingPagePreview.plans}
        viewport={previewViewport}
        onViewportChange={setPreviewViewport}
        partner={toLandingPagePartner(segment, termsOfServiceUrl)}
        logoUrl={segment?.logo ?? undefined}
        brandId={segment?.brandId ? String(segment.brandId) : undefined}
      />
    );
  }

  return (
    <MembershipsConfigPreview
      config={preview.previewConfig}
      branding={preview.previewBranding}
      backgroundImageUrl={preview.previewBackgroundImageUrl}
    />
  );
};
